// extracted by mini-css-extract-plugin
module.exports = {"ulWrapper":"ZO8kR","liWrapper":"_3GMf7"};